module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/avatars/bootstrap-9e4ede4038e2f7efbfc73c30afaec46d.svg";